"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vdlPrefix = void 0;
function vdlPrefix(className) {
  var _a;
  if (!((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.VDL_PREFIX)) {
    return 'vdl-' + className;
  } else {
    return process.env.VDL_PREFIX + className;
  }
}
exports.vdlPrefix = vdlPrefix;